import { UserOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';

export interface IApplicantOption {
  id: string;
  name: string;
  pendingCount: number;
}

export interface IEvidenceApplicantSwitcherProps {
  applicants: IApplicantOption[];
  activeIndividualId: string;
  onSelect: (individualId: string) => void;
}

export const EvidenceApplicantSwitcher = ({
  applicants,
  activeIndividualId,
  onSelect,
}: IEvidenceApplicantSwitcherProps) => {
  return (
    <Flex align='center' className='w-fit rounded-md bg-gray-100 p-0.5 gap-2'>
      {applicants.map(applicant => {
        const isActive = applicant.id === activeIndividualId;
        const activeColorClass = isActive ? 'text-black' : 'text-black text-opacity-40';

        return (
          <Button
            key={applicant.id}
            type='text'
            className={`flex h-auto items-center gap-2 border-none px-3 py-1 shadow-none ${
              isActive ? 'bg-white hover:!bg-white' : 'bg-transparent'
            }`}
            onClick={() => onSelect(applicant.id)}
          >
            <UserOutlined className={`text-base ${activeColorClass}`} />
            <Typography.Text className={`text-sm font-normal ${activeColorClass}`}>{applicant.name}</Typography.Text>
            {applicant.pendingCount > 0 && (
              <span className='flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-center text-xs font-normal leading-none text-white bg-red-500'>
                {applicant.pendingCount}
              </span>
            )}
          </Button>
        );
      })}
    </Flex>
  );
};
